import { observer } from "mobx-react-lite"

import { CodingGuidelinesDialogContent } from "@/components/CodingGuidelinesDialog/CodingGuidelinesDialogContent.tsx"
import { Vertical } from "@/components/Flex.ts"
import { Heading2 } from "@/components/Heading/Heading.tsx"

import type { CodingGuidelinesDialogModel } from "@/components/CodingGuidelinesDialog/CodingGuidelinesDialogModel.ts"


export const ProjectCodingGuidelinesTab = observer((props: {
  model: CodingGuidelinesDialogModel
}) => {

  return (
    <Vertical gap="16px">
      <Heading2>Coding Guidelines</Heading2>
      <CodingGuidelinesDialogContent model={props.model} />
    </Vertical>
  )
})
